var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-application",staticStyle:{"overflow-y":"hidden"}},[_c('v-app',[_c('v-main',[_c('Form'),(_vm.state.appStage.currentProgress == 'success')?_c('Success'):_vm._e()],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }